export const environment = {
    production: true,
    apiUrl: 'https://idocsxdportal.mcdermott.com/api',
    apiUrlNoProxy: 'https://idocsxdportal-api.mcdermott.com/api',
    apiConfig: {
        scopes: ['https://idocsxdportal.mcdermott.com/idocsxdportal'],
        uri: 'https://idocsxdportal.mcdermott.com'
    },
    msalConfig: {
        auth: {
            clientId: '06d66ea1-c60a-413d-bce4-ba65a219d938',
            authority: 'https://login.microsoftonline.com/73faca80-f981-4662-85da-6c374785348d'
        }
    },
};
